exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-list[data-v-53646448]{position:relative;background-color:#fff}.alert-list__item[data-v-53646448]{transition:opacity .2s ease-out,transform .2s ease-out}.alert-list__item[data-v-53646448]:nth-child(n+2){margin-top:2px}.fade-in-enter[data-v-53646448],.fade-in-leave-to[data-v-53646448]{opacity:0;transform:translateY(-8%)}.fade-in-leave-active[data-v-53646448]{position:absolute;width:100%}", ""]);

// exports
